import type { ApprovalRecordDto } from '@nsb/core';
import { dateWords } from '../../days.ts';

/**
 * The line a gate approved by the client and recorded by NSB reads on NSB's panel: "Approved by the client · May 14,
 * 2021, recorded by Jason"; in a step's list, without who recorded it (`by` false), as a list row has room for.
 */
export function recordedWords(r: Pick<ApprovalRecordDto, 'on' | 'recordedBy'>, o: { by?: boolean } = {}): string {
  const by = o.by === false ? null : r.recordedBy?.trim().split(/\s+/)[0];
  return `Approved by the client · ${dateWords(r.on, 'date')}${by ? `, recorded by ${by}` : ''}`;
}
